export const FETCH_DASHBOARDS_REQUEST = 'mapAnalytics/FETCH_DASHBOARDS_REQUEST'
export const FETCH_DASHBOARDS_SUCCESS = 'mapAnalytics/FETCH_DASHBOARDS_SUCCESS'
export const FETCH_DASHBOARDS_FAILURE = 'mapAnalytics/FETCH_DASHBOARDS_FAILURE'

export const FETCH_DASHBOARD_DATA_REQUEST =
  'mapAnalytics/FETCH_DASHBOARD_DATA_REQUEST'
export const FETCH_DASHBOARD_DATA_SUCCESS =
  'mapAnalytics/FETCH_DASHBOARD_DATA_SUCCESS'
export const FETCH_DASHBOARD_DATA_FAILURE =
  'mapAnalytics/FETCH_DASHBOARD_DATA_FAILURE'

export const UPDATE_FIELD = 'mapAnalytics/UPDATE_FIELD'
export const SET_DEFAULT_DATA = 'mapAnalytics/SET_DEFAULT_DATA'
